import { cn } from '../../lib/utils'

const variants = {
  success: 'bg-teal-50 text-teal-700 border border-teal-100',
  warning: 'bg-amber-50 text-amber-700 border border-amber-100',
  danger: 'bg-red-50 text-red-700 border border-red-100',
  info: 'bg-blue-50 text-blue-700 border border-blue-100',
  navy: 'bg-navy-50 text-navy-700 border border-navy-100',
  gold: 'bg-gold-50 text-gold-700 border border-gold-100',
  gray: 'bg-gray-100 text-gray-700 border border-gray-200',
}

export default function Badge({ children, variant = 'gray', className, dot = false }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium',
        variants[variant],
        className
      )}
    >
      {dot && <span className="w-1.5 h-1.5 rounded-full bg-current" />}
      {children}
    </span>
  )
}